import {
  IBulkSendStatusOption,
  TBulkResultsState,
  TBulkSendCsvKind,
  TBulkSendRowStatus,
  TBulkSendStatus,
} from '../types/bulkSendManager';
import { TUserTaskFinalStatus, TUserTaskStatus } from '../types/userTask';

export const BULK_SEND_MANAGER_TITLE = 'Bulk Send Manager';

export const BULK_SEND_STATUS_LABEL: Record<TBulkSendRowStatus, string> = {
  waiting: 'Waiting to start',
  processing: 'Processing',
  completed_with_errors: 'Completed with errors',
  completed: 'Completed',
  failed: 'Failed',
};

export const BULK_SEND_STATUS_OPTIONS: IBulkSendStatusOption[] = [
  { value: 'processing', label: BULK_SEND_STATUS_LABEL.processing },
  { value: 'completed_with_errors', label: BULK_SEND_STATUS_LABEL.completed_with_errors },
  { value: 'completed', label: BULK_SEND_STATUS_LABEL.completed },
  { value: 'failed', label: BULK_SEND_STATUS_LABEL.failed },
];

export const BULK_SEND_IN_PROGRESS_STATUS: TUserTaskStatus = 'in_progress';

export const BULK_SEND_BE_STATUS: Record<TBulkSendStatus, TUserTaskStatus> = {
  processing: BULK_SEND_IN_PROGRESS_STATUS,
  completed: 'completed',
  completed_with_errors: 'completed_with_errors',
  failed: 'failed',
};

export const BULK_SEND_ROW_STATUS_BY_BE_STATUS: Record<string, TBulkSendRowStatus> = {
  completed: 'completed',
  completed_with_errors: 'completed_with_errors',
  failed: 'failed',
};

export const BULK_SEND_UNRECOGNISED_STATUS: TBulkSendRowStatus = 'processing';

export const BULK_SEND_FINISHED_STATUSES: TBulkSendRowStatus[] = ['completed', 'completed_with_errors', 'failed'];

export const BULK_SEND_FINAL_BE_STATUSES: TUserTaskFinalStatus[] = ['completed', 'completed_with_errors', 'failed'];

export const BULK_SEND_NOTIFIER_LIMIT = 50;

export const BULK_SEND_UNTITLED_LABEL = 'Bulk send';

export const BULK_SEND_FINAL_STATUS_MESSAGE: Record<TUserTaskFinalStatus, string> = {
  completed: 'completed',
  completed_with_errors: 'completed with errors',
  failed: 'failed',
};

export const BULK_SEND_FILTER_LABEL = {
  status: 'Status',
  created: 'Created',
};

export const BULK_SEND_COLUMN_WIDTH = {
  sendId: 264,
  status: 192,
  recipients: 108,
  failed: 84,
  created: 230,
  results: 200,
};

export const BULK_SEND_TITLE_MIN_WIDTH = 320;

export const BULK_SEND_TITLE_MAX_WIDTH = 560;

export const BULK_SEND_FIXED_COLUMNS_WIDTH = Object.values(BULK_SEND_COLUMN_WIDTH).reduce(
  (total, width) => total + width,
  0,
);

export const BULK_SEND_TABLE_MIN_WIDTH = BULK_SEND_FIXED_COLUMNS_WIDTH + BULK_SEND_TITLE_MIN_WIDTH;

export const BULK_SEND_COLUMN_LABEL = {
  title: 'Title',
  sendId: 'Send ID',
  status: 'Status',
  recipients: 'Recipients',
  failed: 'Failed',
  created: 'Created',
  results: 'Results',
};

export const BULK_SEND_RESULTS_COPY: Record<TBulkResultsState, string> = {
  unavailable: 'Available when finished',
  can_generate: 'Generate CSV files',
  pending: 'Preparing files…',
  ready: 'Download CSV',
  retry: 'Generate CSV files',
};

export const BULK_SEND_TASK_TYPE = 'bulk_send';

export const BULK_SEND_DATE_VALUE_FORMAT = 'yyyy-MM-dd';

export const USER_TASKS_COLLECTION = 'user_tasks';

export const BULK_SEND_ORDER_FIELD = 'created_at';

export const BULK_SEND_CSV_MENU_LABEL: Record<TBulkSendCsvKind, string> = {
  successful: 'Successful recipients',
  failed: 'Failed recipients',
};

export const BULK_SEND_CSV_MENU_ARIA_LABEL = 'Download CSV files';

export const BULK_SEND_CSV_ERROR_TOOLTIP = "Couldn't prepare the files. Generate them again.";

export const BULK_SEND_CSV_READY_MESSAGE = 'CSV files are ready to download.';

export const BULK_SEND_CSV_FAILED_MESSAGE = "Couldn't prepare the CSV files. Please try again.";

export const BULK_SEND_CREATED_FORMAT = 'd MMM yyyy, HH:mm:ss';

export const BULK_SEND_UNKNOWN_FAILED_LABEL = 'Not known until the send finishes';

export const BULK_SEND_EMPTY_TITLE = 'No bulk sends to show';

export const BULK_SEND_FILTERED_EMPTY_TITLE = 'No bulk sends match these filters';

export const BULK_SEND_CLEAR_FILTERS_LABEL = 'Clear filters';

export const BULK_SEND_ERROR_TITLE = 'Bulk sends could not be loaded';

export const BULK_SEND_ERROR_SUBTITLE = 'Refresh the page to try again';

export const BULK_SEND_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const MAX_BULK_SENDS_PER_PAGE = 10;
